import ItemCreationForm from 'VueComponents/ItemCreation/Form';
import ItemCreationModal from 'VueComponents/ItemCreation/Modal';

export default {
  components: {
    ItemCreationForm,
    ItemCreationModal,
  },
  data() {
    return {
      item_qc_modal: 'item-create-modal',
      quick_create_asset: null,
    };
  },
  methods: {
    initQuickCreateModal(asset) {
      // Re-init the component and show the modal
      this.quick_create_asset = null;
      this.$nextTick(() => {
        this.quick_create_asset = asset;
        this.fireModal(`item-create-modal`);
      });
    },
  },
};
